import * as tslib_1 from "tslib";
import * as React from 'react';
import { FocusOn as ReactFocusOn } from './UI';
import SideCar from './sidecar';

var RequireSideCar = function RequireSideCar(props) {
  return React.createElement(SideCar, tslib_1.__assign({}, props));
};

export var FocusOn = React.forwardRef(function (props, ref) {
  return React.createElement(ReactFocusOn, tslib_1.__assign({}, props, {
    ref: ref,
    sideCar: RequireSideCar
  }));
});